"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxiosInstance = exports.getBaseUrl = void 0;
const axios_1 = __importDefault(require("axios"));
const consts_1 = require("./consts");
const shared_1 = require("./models/shared");
const axios_retry_1 = __importStar(require("axios-retry"));
const getBaseUrl = (env, options) => {
    if (options === null || options === void 0 ? void 0 : options.baseUrl)
        return options === null || options === void 0 ? void 0 : options.baseUrl;
    switch (env) {
        case shared_1.Env.INTEGRATION:
            return consts_1.siIntBaseUrl;
        case shared_1.Env.PRODUCTION:
            return consts_1.siProdBaseUrl;
        case shared_1.Env.DEVELOPMENT:
            return consts_1.siLocalHostBaseUrl;
        default:
            throw new Error(`Invalid Baton environment: ${env}`);
    }
};
exports.getBaseUrl = getBaseUrl;
const getAxiosInstance = (options) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const client = axios_1.default.create();
    const noOfRetries = (_a = options === null || options === void 0 ? void 0 : options.numRetries) !== null && _a !== void 0 ? _a : 3;
    const retryDelay = (_b = options === null || options === void 0 ? void 0 : options.retryDelay) !== null && _b !== void 0 ? _b : 200;
    const retryCondition = (_c = options === null || options === void 0 ? void 0 : options.retryCondition) !== null && _c !== void 0 ? _c : axios_retry_1.isNetworkOrIdempotentRequestError;
    (0, axios_retry_1.default)(client, {
        retries: noOfRetries,
        retryCondition,
        retryDelay: (retryCount) => {
            return retryCount * retryDelay;
        }
    });
    (_e = (_d = options === null || options === void 0 ? void 0 : options.interceptors) === null || _d === void 0 ? void 0 : _d.request) === null || _e === void 0 ? void 0 : _e.forEach(([onFulfilled, onRejected]) => client.interceptors.request.use(onFulfilled, onRejected));
    (_g = (_f = options === null || options === void 0 ? void 0 : options.interceptors) === null || _f === void 0 ? void 0 : _f.response) === null || _g === void 0 ? void 0 : _g.forEach(([onFulfilled, onRejected]) => client.interceptors.response.use(onFulfilled, onRejected));
    return client;
};
exports.getAxiosInstance = getAxiosInstance;
